// i18n area 'storage' — locale pt-BR (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da storage.pt-PT.ts e sovrascrive SOLO le chiavi
// che il brasiliano scrive davvero in un altro modo: lessico (usuário,
// arquivo, tela, senha, registro, seção, configurações, salvar, console) e
// morfologia verbale (il progressivo 'está a fazer' → 'está fazendo').
// DA RIVEDERE DA MADRELINGUA: restano fuori le scelte a bassa confidenza
// (alojar/hospedar, eliminar/excluir, arranque/inicialização) e la posizione
// dei clitici, che una regola meccanica non sa spostare.
// Sidecar anti-stantie: ../meta/storage.pt-BR.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './storage'

export const ptBR: DeepPartial<typeof enUS> = {
  storage: {
    pools: {
      cardConnection: 'Conexão',
      content: {
        catalogFiles: 'Arquivos de catálogo'
      }
    },
    lost: {
      confirmBody: 'Atestação do operador por sua conta e risco declarado: cada task em fila ou em curso sobre este storage ou os seus objetos irá FALHAR, as eliminações passam a ser apenas de registro (nenhum trabalho no filesystem) e o novo trabalho físico é recusado. Os bytes nunca são tocados — se o volume voltar à vida, registe-o de novo e execute um scan para readotar tudo.'
    },
    findings: {
      kind: {
        catalogFile: 'Arquivo de catálogo'
      },
      adoptFileHint: 'Os arquivos só existem dentro dos catálogos: escolha o catálogo de destino para o arquivo encontrado.'
    },
    wizard: {
      username: 'Nome de usuário',
      password: 'Senha',
      dhchapCredentialHint: 'Uma entrada do keystore do tipo DH-HMAC-CHAP (NVMe) usada na conexão — o segredo nunca viaja com o storage.',
      dhchapEmpty: 'Nenhuma credencial do tipo DH-HMAC-CHAP (NVMe) no keystore — crie-a em Sistema → Credenciais. Sem ela, a conexão fica não autenticada.'
    },
    catalogs: {
      scopeHint: 'Quem lê este scope vê (e pode usar) todos os arquivos do catálogo',
      files: 'Arquivos',
      noFiles: 'Nenhum arquivo'
    },
    catalogFiles: {
      formatHint: 'Derivado da extensão do arquivo escolhido — corrija-o se adivinhou mal',
      uploadResumeHint: 'Upload interrompido — o arquivo está à espera de upload: submeta de novo com o mesmo arquivo para retomar',
      moveTitle: 'Mover arquivo',
      moveHint: 'Duas dimensões independentes: o Catálogo move a ligação (mesmo id, nenhum byte se move, o scope passa a ser o do catálogo de destino); o Storage move os dados — cada cópia ligada segue-o, recusado enquanto o arquivo estiver em uso. Escolhidos em conjunto: primeiro o catálogo, depois o storage.',
      moveCatalogHint: 'Só a ligação muda de casa: uma VM que monta o arquivo tem de conseguir ver o catálogo de destino',
      copyCatalogHint: 'A cópia é a forma como um arquivo viaja entre catálogos',
      sharedObjectHint: 'Os dados deste arquivo são partilhados por {count} cópias ligadas',
      embeddedNoMove: 'Arquivo integrado da plataforma: não vive em nenhum storage — clone-o em vez disso',
      embeddedCopyHint: 'O clone materializa os bytes integrados num storage real: escolha o storage e o catálogo de destino — a cópia é um arquivo normal',
      downloadNotReady: 'O conteúdo ainda não está pronto — o download exige um arquivo ready',
      downloadDenied: 'O seu papel não inclui catalog.download — transferir os bytes é um direito separado do uso do arquivo'
    },
    objects: {
      hint: 'Censo só de leitura do que vive neste storage — cada objeto é gerenciado na sua própria seção.',
      manage: 'Gerenciar na sua seção',
      kind: {
        catalogFile: 'Arquivo de catálogo'
      }
    },
    inventory: {
      sourceFile: 'Upload de arquivo',
      file: 'Arquivo',
      checksumOffHint: 'O download será aceito sem verificação — o SHA-256 calculado é registado na mesma',
      uploading: 'Enviando…'
    }
  }
}
